import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

const offViewportCss = css`
  left: ${({ offsetToRight }) => offsetToRight};
`;

export const SubMenuContainer = styled.div`
  padding: 15px;
  min-width: 200px;
  z-index: 1;
  background-color: #fff;
  position: absolute;
  box-shadow: 0 0 22px 1px #d6d6d6;
  top: 50px;
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  ${offViewportCss};
`;
